import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';

import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { VisualsService } from '@core/Abstract/visuals.service';
import { FieldConfig } from '../../models/field-config.interface';
import { DynamicFormService } from 'app/dynamic-form/containers/dynamic-form/dynamic-form.service';

@Component({
  exportAs: 'dynamicForm',
  selector: 'dynamic-form',
  templateUrl: './dynamic-form.component.html',
  providers: [DynamicFormService]
})
export class DynamicFormComponent implements OnChanges, OnInit {

  @Input() visuals: any;
  @Input() genericVisuals: any;
  @Input() group: string;
  @Input() serviceName: string;
  @Input() loading: boolean;
  @Input() formErrors: any;
  private strokeColor: "red";

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  formChanges: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  modalOutput: EventEmitter<any> = new EventEmitter<any>();
  public valueChanged(modalname: string, value: any) {
    this.modalOutput.emit(
      {
        'modalname': modalname,
        'value': value
      }
    );
  }

  form: UntypedFormGroup;
  protected formFieldConfig: FieldConfig[] = [];

  get controls() { return this.formFieldConfig.filter(({ type }) => type !== 'button'); }
  get changes() { return this.form.valueChanges; }
  get valid() { return this.form.valid; }
  get value() { return this.form.value; }

  protected dateRegex = /(^(((0[1-9]|1[0-9]|2[0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9])\d\d$)|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
  protected intRegex = /(^0$)|(^[1-9]\d*$)/;
  protected decimalRegex = /^[0-9]+(\.[0-9]{1,2})?$/;

  constructor(private fb: UntypedFormBuilder, protected visualsService: VisualsService,
    protected eventsEmitterService: EventsEmitterService, protected ref: ChangeDetectorRef, private dynamicFormService: DynamicFormService) {

    this.eventsEmitterService.languageChange.subscribe(
      langId => {
        this.getLookUp();
      }
    );
  }

  ngOnInit() {
    if( this.group ){
      this.dynamicFormService.getFormFieldDefinition({ "group": this.group }).subscribe(
        data => {
          this.formFieldConfig = data;
          this.getLookUp();
          this.form = this.createGroup();
          this.formChanges.emit(this.formFieldConfig);
        },
        error => {
          console.error("Could not get FormFieldDefinition")
        }
      );
    }
  }

  ngOnChanges() {
    if (this.formFieldConfig.length > 0 && this.form) {
      const controls = Object.keys(this.form.controls);
      const configControls = this.controls.map((item) => item.name);

      controls
        .filter((control) => !configControls.includes(control))
        .forEach((control) => this.form.removeControl(control));

      configControls
        .filter((control) => !controls.includes(control))
        .forEach((name) => {
          const config = this.formFieldConfig.find((control) => control.name === name);
          this.form.addControl(name, this.createControl(config));
        });
    }
  }

  public loadFormFieldDefinitions(){
    if (this.group){
      this.dynamicFormService.getFormFieldDefinition({ "group": this.group }).subscribe(
        data => {
          this.formFieldConfig = data;
          this.getLookUp();
          this.form = this.createGroup();
          this.formChanges.emit(this.formFieldConfig);
        },
        error => {
          console.error("Could not get FormFieldDefinition")
        }
      );
    }
  }

  createGroup() {
    let group = this.fb.group({});
    if (this.formFieldConfig.length > 0) {
      this.controls.forEach(control => { group.addControl(control.name, this.createControl(control)) });
    }
    return group;
  }

  createControl(config: FieldConfig) {
    const { disabled, validation, value } = config;

    /**
     * Create Validators object from string
     */
    let validator: ValidatorFn[] = [];
    let validationAr: Array<string> = validation ? validation.split(',') : [];
    validationAr.forEach(rule => {
      if (rule === 'R') {
        validator.push(Validators.required);
      } else if (rule === 'T') {
        validator.push(Validators.pattern(this.dateRegex));
      } else if (rule === 'D') {
        validator.push(Validators.pattern(this.dateRegex));
      } else if (rule === 'I') {
        validator.push(Validators.pattern(this.intRegex));
      } else if (rule === 'N') {
        validator.push(Validators.pattern(this.decimalRegex));
      }
    });

    return this.fb.control({ disabled, value }, validator);
  }

  handleSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    //this.form.value.formType = this.type;
    console.log(this.value);
    this.submit.emit(this.value);
    this.form.reset();
  }

  setDisabled(name: string, disable: boolean) {
    if (this.form.controls[name]) {
      const method = disable ? 'disable' : 'enable';
      this.form.controls[name][method]();
      return;
    }

    this.formFieldConfig = this.formFieldConfig.map((item) => {
      if (item.name === name) {
        item.disabled = disable;
      }
      return item;
    });
  }

  setValue(name: string, value: any) {
    this.form.controls[name].setValue(value, { emitEvent: true });
  }

  setFormGroupValues(controls: any) {
    this.form.patchValue(controls, { emitEvent: true });
  }

  changeStroke(event) {
    this.form.controls['strokeColor'].setValue(event, { emitEvent: true });
  }

  /**
   * ngx-select (module Output)
   * Option Selected
   */
  setValueSelected(name, value) {
    //console.log(name)
    //console.log(value)
  }

  /**
   * ngx-select
   * set options array from localstorage
   */
  getLookUp() {
    this.formFieldConfig.forEach(element => {
      if (element.type == 'select' && element.lookupname != null && element.lookupname != '') {
        let required = element.validation == "R" ? true : false;
        element.lookup = this.visualsService.getLkpFromStorageAsJSON(element.lookupname, required);
      }
    });
  }

  getClassReq(validations: string) {
    if (validations != null && (validations).indexOf('R') !== -1) {
      return "input-required";
    } else {
      return "";
    }
  }


}
